'use strict';

var HybridCorePricingConfig = function HybridCorePricingConfig($stateProvider) {
  $stateProvider.state('app.fo-core-pricing', {
    url: '/workflow/fo-core-pricing',
    ifFeatureEnabled: ['FARES_OPTIMIZER;CORE_PRICING'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: '<corepricing class="react-pages"> </corepricing>'
      }
    }
  });
};
module.exports = HybridCorePricingConfig;
HybridCorePricingConfig.$inject = ['$stateProvider'];